import { createFileRoute } from '@tanstack/react-router';
import { Prose } from '@leanin/ui/server';
import { LegalShell } from '@/components/legal/LegalShell';
import privacyMarkdown from '../content/legal/privacy.md?raw';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy">
      <Prose source={privacyMarkdown} />
    </LegalShell>
  );
}
